export default __webpack_public_path__ + "static/media/IMG_1602.dda8e4ec.jpeg";